import { motion } from "framer-motion";

const Impressum = () => (
  <main className="pt-24 pb-20 bg-[#F8F5F0]" data-testid="impressum-page">
    <div className="max-w-3xl mx-auto px-4 sm:px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <p className="uppercase tracking-[0.3em] text-xs text-[#8B5E3C] font-manrope mb-3">Rechtliches</p>
        <h1 className="font-playfair text-4xl text-[#2B2B2B] mb-10">Impressum</h1>

        <div className="space-y-8 font-manrope text-[#2B2B2B]/70 text-sm leading-relaxed">
          <section>
            <h2 className="font-playfair text-xl text-[#2B2B2B] mb-3">Angaben gemäß § 5 TMG</h2>
            <p>
              Marcus Loos<br />
              Schreinerei & Bestattungen Loos<br />
              Lorenkamp 4<br />
              45721 Haltern am See
            </p>
          </section>

          <section>
            <h2 className="font-playfair text-xl text-[#2B2B2B] mb-3">Kontakt</h2>
            <p>
              Telefon (Schreinerei): 02364 / 5042567<br />
              Telefon (Bestattungshaus): 02364 / 2384<br />
              24/7 Notfall: 0171 / 4312224<br />
              Bestattungshaus: Mühlenstraße 6, 45721 Haltern am See
            </p>
          </section>

          <section>
            <h2 className="font-playfair text-xl text-[#2B2B2B] mb-3">Berufsbezeichnung und berufsrechtliche Regelungen</h2>
            <p>
              Schreinermeister (Deutschland)<br />
              Bestatter (Deutschland)<br />
              Zuständige Kammer: Handwerkskammer Münster<br />
              Zuständige Aufsichtsbehörde: Ordnungsamt Haltern am See
            </p>
          </section>

          <section>
            <h2 className="font-playfair text-xl text-[#2B2B2B] mb-3">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <p>
              Marcus Loos<br />
              Lorenkamp 4<br />
              45721 Haltern am See
            </p>
          </section>

          <section>
            <h2 className="font-playfair text-xl text-[#2B2B2B] mb-3">Streitschlichtung</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
              https://ec.europa.eu/consumers/odr/. Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
            <p className="mt-3">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section>
            <h2 className="font-playfair text-xl text-[#2B2B2B] mb-3">Haftungsausschluss</h2>
            <p>
              Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit,
              Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
            </p>
          </section>

          <div className="border-t border-[#8B5E3C]/15 pt-6 text-xs text-[#2B2B2B]/40">
            <em>Dieses Impressum dient als Demo-Mustertext und muss vor dem Live-Betrieb durch einen Rechtsanwalt geprüft und angepasst werden.</em>
          </div>
        </div>
      </motion.div>
    </div>
  </main>
);

export default Impressum;
